<div>
    <div *ngFor='let key of schema.properties | keys; let i=index;'>
        <h1>{{key}}</h1>
        <sf-form-element [formProperty]='formProperty.getProperty(key)'>
            <!--{{formProperty}}-->
        </sf-form-element>
    </div>
</div>
